import type { FaireProductEntity } from "../../entity_types/product";

export const p_7e8gk3nabi: FaireProductEntity = {
  token: "p_7e8gk3nabi",
  type: "product",
  name: "Bath Bombs Lot - 25 Pieces",
  brandToken: "b_5e4msa2g",
  brandName: "Steele Family Farm",
  imageUrl:
    "https://cdn.faire.com/fastly/e4275a866b99e53c3e7b925f5f0accae136dced2ae714ebf54033117dc5c5d66.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b57ec2773d0771d76e5a24a4b1a55c4fee66a58704ef75e5fefd2fe925127eeb.jpeg",
    "https://cdn.faire.com/fastly/268816c3c7852486a76a383d9abd9b97bbe58cadf0491c9e294f0c4892b0a839.jpeg",
  ],
  priceDollars: 2,
  description:
    "Includes 25 Handcrafted Goat Milk Bath Bombs in a variety of scents. Perfect to display in a basket or bucket.\n\nSize: 2-inch bombs",
  tags: [],
  msrpDollars: 4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:03.648Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
